import { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Breadcrumb from 'components/breadcrumbs';
import useStyles from './index.styles';
import AccordianSummaryContent from './summaryContent';

import campaignImage from '../../assets/campaign-management.png';
import automatedCollectionImage from '../../assets/automated-collections-strategy.png';

const steps = {
  campaign: ['Upload File', 'Run Campaign'],
  strategy: ['Connect your DB', 'Review Strategy', 'Activate it'],
  template: ['Create Template', 'View, Edit and Delete option'],
};

const SubscriptionScreen = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <div className={classes.subscriptionWrapper}>
      <Breadcrumb nested='KollectAI Subscriptions' showNested />
      <div className={classes.subscribedCont}>
        <Typography variant='h6' sx={{ fontWeight: 600, marginBottom: '10px' }}>
          Subscribed Tools
        </Typography>

        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <AccordianSummaryContent
              title='Campaign Management tool'
              steps={steps.campaign}
              activated={true}
            />
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ padding: '2rem 5rem' }}>
              <img src={campaignImage} alt='' width={'100%'} />
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <AccordianSummaryContent
              title='Segmented - Automated collection strategy'
              steps={steps.strategy}
              activated={true}
            />
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ padding: '2rem 5rem' }}>
              <img src={automatedCollectionImage} alt='' width={'100%'} />
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <AccordianSummaryContent
              title='Template Management tool'
              steps={steps.template}
              activated={false}
            />
          </AccordionSummary>
          <AccordionDetails></AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default SubscriptionScreen;
